import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios, { API } from "@/lib/api";
import { Toaster } from "@/components/ui/sonner";
import AuthPage from "@/components/AuthPage";
import AuthCallback from "@/components/AuthCallback";
import PasswordProtection from "@/components/PasswordProtection";
import Dashboard from "@/components/Dashboard";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const appAuth = localStorage.getItem('app_authenticated');
      if (appAuth === 'true') {
        setIsAuthenticated(true);
      }

      try {
        const response = await axios.get(`${API}/auth/status`);
        if (response.data.authenticated && response.data.user) {
          setUser(response.data.user);
          localStorage.setItem('youtube_auth', JSON.stringify(response.data.user));
        } else {
          const storedAuth = localStorage.getItem('youtube_auth');
          if (storedAuth) {
            try {
              const authData = JSON.parse(storedAuth);
              if (authData && authData.channel_id && authData.name) {
                setUser(authData);
              } else {
                localStorage.removeItem('youtube_auth');
              }
            } catch {
              localStorage.removeItem('youtube_auth');
            }
          }
        }
      } catch {
        const storedAuth = localStorage.getItem('youtube_auth');
        if (storedAuth) {
          try {
            const authData = JSON.parse(storedAuth);
            if (authData && authData.channel_id && authData.name) {
              setUser(authData);
            }
          } catch {
            localStorage.removeItem('youtube_auth');
          }
        }
      }

      setLoading(false);
    };

    checkAuth();
  }, []);

  const handleAuth = (authData) => {
    const userData = authData.user || authData;
    setUser(userData);
    localStorage.setItem('youtube_auth', JSON.stringify(userData));
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (error) {
      console.error('Logout error:', error);
    }

    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('youtube_auth');
    localStorage.removeItem('app_authenticated');
    window.location.href = '/';
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-red-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="App">
        <Toaster position="top-right" />
        <PasswordProtection onAuthenticated={setIsAuthenticated} />
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/auth/callback" element={<AuthCallback onAuth={handleAuth} />} />
          <Route path="/" element={
            user ? <Dashboard user={user} onLogout={handleLogout} /> : <AuthPage onAuth={handleAuth} />
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
